import React from "react";
import { useFont } from "../../contexts/FontContext/FontContext";
import styles from "./Footer.module.css";

const Footer = () => {

	const fontSchemes = useFont();    
  	const fontFamilyThree = fontSchemes.scheme_three; 

	return (
		<div className={styles.footer}>
			<div className={`${styles.footer_section} ${styles.left_section}`}>
				<img src={`${process.env.PUBLIC_URL}/images/logo.png`} className={styles.footer_logo} alt="footer_logo" />
				<div className={styles.copyright_wrapper}>
					<p className={styles.copyright}>© 2026 Shipwheel. All rights reserved.</p>
				</div>
			</div>
			<div className={`${styles.footer_section} ${styles.right_section}`}>
				<div className={`${styles.sub_section} ${styles.left_sub_section}`}>
					<p className={`${styles.footer_titles} ${styles.company_title} ${fontFamilyThree}`}>Company</p>
					<p className={`${styles.footer_items} ${styles.about} ${fontFamilyThree}`}>About</p>
					<p className={`${styles.footer_items} ${styles.terms_and_conditions} ${fontFamilyThree}`}>Terms and conditions</p>
				</div>
				<div className={`${styles.sub_section} ${styles.right_sub_section}`}>
					<p className={`${styles.footer_titles} ${styles.contact_us} ${fontFamilyThree}`}>Contact us</p>
					<p className={`${styles.footer_items} ${styles.address} ${fontFamilyThree}`}>Address</p>
					<p className={`${styles.footer_items} ${styles.email} ${fontFamilyThree}`}><a href="mailto:jakeziscoding@gmail.com">Email</a></p>
				</div>
			</div>
		</div>
	);
}

export default Footer;